export const ALLOWED_AUDIO_EXTENSIONS = ['.mp3', '.wav', '.ogg', '.m4a', '.aac']

export const ALLOWED_AUDIO_ACCEPT =
  '.mp3,.wav,.ogg,.m4a,.aac,audio/mpeg,audio/wav,audio/ogg,audio/mp4,audio/aac'

const ALLOWED_AUDIO_MIME_TYPES = new Set([
  'audio/mpeg',
  'audio/mp3',
  'audio/wav',
  'audio/x-wav',
  'audio/wave',
  'audio/ogg',
  'audio/mp4',
  'audio/x-m4a',
  'audio/aac',
  'audio/x-aac'
])

export const resolveAudioFileName = audioBlob => {
  const name = typeof audioBlob?.name === 'string' ? audioBlob.name.trim() : ''
  if (name) {
    const ext = name.includes('.') ? name.slice(name.lastIndexOf('.')).toLowerCase() : ''
    if (ALLOWED_AUDIO_EXTENSIONS.includes(ext)) return name
  }

  const type = String(audioBlob?.type || '').toLowerCase().split(';')[0].trim()
  if (type.includes('mpeg') || type.includes('mp3')) return 'sound.mp3'
  if (type.includes('wav')) return 'sound.wav'
  if (type.includes('ogg')) return 'sound.ogg'
  if (type.includes('mp4') || type.includes('m4a')) return 'sound.m4a'
  if (type.includes('aac')) return 'sound.aac'
  return 'sound.mp3'
}

export const validateAudioBlob = audioBlob => {
  if (!audioBlob || !(Number(audioBlob.size) > 0)) {
    return { ok: false, message: 'No audio file selected.' }
  }

  const name = typeof audioBlob?.name === 'string' ? audioBlob.name.trim() : ''
  const ext = name.includes('.') ? name.slice(name.lastIndexOf('.')).toLowerCase() : ''
  if (ext && ALLOWED_AUDIO_EXTENSIONS.includes(ext)) {
    return { ok: true }
  }

  const mime = String(audioBlob?.type || '').toLowerCase().split(';')[0].trim()
  if (mime && ALLOWED_AUDIO_MIME_TYPES.has(mime)) {
    return { ok: true }
  }

  return {
    ok: false,
    message: 'Unsupported audio format. Use MP3, WAV, OGG, M4A, or AAC.'
  }
}

export const appendAudioFile = (formData, audioBlob) => {
  formData.append('audioFile', audioBlob, resolveAudioFileName(audioBlob))
}

export const extractAudioUploadErrorMessage = error => {
  const apiMessage = error?.response?.data?.message
  if (typeof apiMessage === 'string' && apiMessage.trim()) {
    return apiMessage.trim()
  }
  return null
}
